import clickElement from "./click-element";
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';

/**
 * 新建自定义积木块时，点击上面的添加参数和标签按钮
 * @param args.index 第几个按钮
 * @param {...} args 除了index之外，其他参数与clickElement保持一致
 * @returns {Promise}
 */
export default function clickCustomProcedureOption(args) {
    if (!args.tips) args.tips = "点击这里添加" + (args.index == 2 ? '标签' : '参数');
    Audio.tts(args.tips);
    return clickElement({element: '[class^="custom-procedures_options"]>[class^="custom-procedures_option"]', ...args});
}
